import { useState, useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { SUPPORTED_LANGUAGES_MAP } from "../../util/constants";
import css from "../../containers/TopbarContainer/Topbar/TopbarDesktop/TopbarDesktop.module.css";
import OutsideClickHandler from "react-outside-click-handler"; // ✅ Correct import
import classNames from "classnames";
import CountryFlag from "../../components/CountryFlag/CountryFlag";
import IconArrowHead from "../IconArrowHead/IconArrowHead";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const LanguageSelector = (props) => {
  const {
    currentListing,
    pageAssetsData,
    pageId,
    currentUserLocationInfo,
  } = props;

  const { locale, changeLanguage } = useContext(LanguageContext);

  let defaultOption =
    SUPPORTED_LANGUAGES_MAP[locale] ||
    SUPPORTED_LANGUAGES_MAP["en"];
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  const { country } = currentUserLocationInfo || {};

  useEffect(() => {
    const location = SUPPORTED_LANGUAGES_MAP[locale] ||
      SUPPORTED_LANGUAGES_MAP["en"];
    
    if ((country === "US" || country === "CA") && locale === "en") {
      setSelectedOption({ ...location, countryCode: country });
    } else {
      setSelectedOption(location);
    }
  }, [country, locale]);

  return (
    <div className={css.dropdown} style={{ marginLeft: 16 }}>
      <OutsideClickHandler onOutsideClick={() => setIsDropdownOpen(false)}>
        <div
          className={classNames(
            css.selectedOption,
            isDropdownOpen ? css.selectedOptionOpen : css.selectedOptionClose
          )}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <div className={css.userCurrency}>
            <span className={css.countryFlag}>
              <CountryFlag code={selectedOption.countryCode} height="20" width="20" />
            </span>
            <span>{selectedOption.shortLabel}</span>
          </div>
          <IconArrowHead
            direction="down"
            size="small"
            rootClassName={css.arrowIcon}
          />
        </div>
        {isDropdownOpen && (
          <div className={css.optionsContainer}>
            <div className={css.option}>
              <span>
                <FormattedMessage id="LanguageSelector.heading" />
              </span>
            </div>
            {Object.values(SUPPORTED_LANGUAGES_MAP).map(option => (
              <div
                key={option.code}
                className={classNames(
                  selectedOption.code === option.code && css.activeOptions,
                  css.option
                )}
                onClick={() => {
                  changeLanguage({ locale: option.code, listing: currentListing, pageAssetsData, pageId });
                  setIsDropdownOpen(false);
                }}
              >
                <span>
                  <CountryFlag code={option.countryCode} height="20" width="20" />
                </span>
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </OutsideClickHandler>
    </div>
  );
};

LanguageSelector.propTypes = {
  currentListing: PropTypes.object,
  pageAssetsData: PropTypes.object,
  pageId: PropTypes.string,
  currentUserLocationInfo: PropTypes.object,
};

LanguageSelector.defaultProps = {
  currentListing: null,
  pageAssetsData: null,
  pageId: null,
  currentUserLocationInfo: {},
};

export default LanguageSelector;
